var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"2000","src":"https://datastudio.google.com/embed/reporting/0b2a5ccc-62a7-459a-9a54-b8c678bcf7ca/page/nBFJC","frameborder":"0","allowfullscreen":""}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }